export const EMAILS = {
  ORDERS: 'orders@cellsignal.com',
  INFO: 'info@cellsignal.com',
} as const
export const SITE_NAME = 'cellsignal.com' as const
